module.exports = __webpack_public_path__ + "img/illu-confetti.a6617806.svg";